import { render, staticRenderFns } from "./DynamicScore.vue?vue&type=template&id=17c142f1&scoped=true&"
import script from "./DynamicScore.vue?vue&type=script&lang=ts&"
export * from "./DynamicScore.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicScore.vue?vue&type=style&index=0&id=17c142f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c142f1",
  null
  
)

export default component.exports